import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import auth from "./modules/auth-module";
import common, { initialState } from "./modules/common-module";
import user from "./modules/user-module";
import retail from "./modules/retail-module";
import signUp from "./modules/sign-up-module";
import uploadMedia from "./modules/upload-module";
import retailReferral from "./modules/retail-referral";
import payment from "./modules/payment-module";
import jeet11 from "./modules/jeet11-module";
import finance from "./modules/finance-module";
import tsm from "./modules/tsm-module";
import rummy from "./modules/rummy-module";
import associates from "./modules/my-associates-module";
import agency from "./modules/agency-module";

Vue.use(Vuex);

let oldData = window.localStorage.getItem("state");
let oldVersion = "0.0.0";

if (oldData && typeof oldData === "string") {
	oldData = JSON.parse(oldData);
}
if (oldData && typeof oldData === "object" && "APP_VERSION" in oldData.common) {
	oldVersion = oldData.common.APP_VERSION;
}

if (initialState.APP_VERSION !== oldVersion) {
	console.log("APP UPDATED");
	window.localStorage.removeItem("state"); // force log out
}

// https://github.com/robinvdvleuten/vuex-persistedstate/issues/102

const requestIdleCallback =
	window.requestIdleCallback ||
	(cb => {
		let start = Date.now();
		return setTimeout(() => {
			let data = {
				didTimeout: false,
				timeRemaining() {
					return Math.max(0, 50 - (Date.now() - start));
				}
			};
			cb(data);
		}, 1);
	});

export default new Vuex.Store({
	modules: {
		common,
		auth,
		signUp,
		user,
		retail,
		uploadMedia,
		retailReferral,
		payment,
		jeet11,
		finance,
		tsm,
		rummy,
		associates,
		agency
	},
	plugins: [
		createPersistedState({
			key: "state",
			storage: window.localStorage,
			setState: (key, state, storage) => {
				requestIdleCallback(() => {
					try {
						state = { ...state };
						let allKeys = Object.keys(state);
						allKeys.forEach(stateKey => {
							if (stateKey.indexOf("Loading") !== -1) {
								delete state[stateKey];
							}
						});
						storage.setItem(key, JSON.stringify(state));
					} catch (e) {
						console.warn(e);
					}
				});
			}
		})
	]
});
